import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MetricsService } from '../../../core/services/metrics.service';
import { SaasMetrics } from '../../../core/models/saas.models';
import { environment } from '../../../../environments/environment';
import * as feather from 'feather-icons';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit, AfterViewChecked {
  
  loading: boolean = true;
  hasData: boolean = false;
  private iconsInitialized = false;
  
  // Métricas
  metrics: SaasMetrics = {
    period: '',
    mrr: 0,
    arr: 0,
    activeCustomers: 0,
    newCustomers: 0,
    churnedCustomers: 0,
    churnRate: 0,
    upgrades: 0,
    downgrades: 0,
    addonsRevenue: 0,
    averageTicket: 0,
    ltv: 0,
    cac: 0,
    overdueAccounts: 0,
    suspendedAccounts: 0,
    currency: 'PEN'
  };
  
  // Estadísticas adicionales
  totalSubscriptions: number = 0;
  pendingActivations: number = 0;
  pendingUpgrades: number = 0;

  constructor(private metricsService: MetricsService) { }

  ngOnInit(): void {
    this.loadMetrics();
  }

  ngAfterViewChecked(): void {
    if (!this.iconsInitialized && !this.loading) {
      feather.replace();
      this.iconsInitialized = true;
    }
  }

  /**
   * Carga las métricas del dashboard
   */
  loadMetrics(): void {
    this.loading = true;
    this.hasData = false;
    
    this.metricsService.getMetrics('month').subscribe({
      next: (response: any) => {
        const data = response.data || response;
        
        // Si viene con estructura current/previous
        if (data.current) {
          this.metrics = data.current;
        } else {
          this.metrics = data;
        }
        
        this.hasData = true;
        this.loading = false;
        this.iconsInitialized = false;
        setTimeout(() => feather.replace(), 100);
      },
      error: (error) => {
        console.error('Error cargando métricas:', error);
        this.hasData = false;
        this.loading = false;
        setTimeout(() => feather.replace(), 100);
      }
    });
  }
  
  /**
   * Formatea un número como moneda usando la moneda de las métricas
   */
  formatCurrency(value: number): string {
    const currency = this.metrics.currency || 'PEN';
    const locale = currency === 'PEN' ? 'es-PE' : 'en-US';
    
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }

  /**
   * Exporta las métricas a Excel
   */
  exportToExcel(): void {
    const token = localStorage.getItem('adminToken');
    const period = this.metrics.period || 'month';
    
    // Crear URL con parámetros
    const url = `${environment.adminApiUrl}admin/saas/metrics/export?period=${period}`;
    
    // Crear un elemento <a> temporal para descargar el archivo
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    
    // Configurar headers con el token
    fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `metricas-saas-${period}-${Date.now()}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    })
    .catch(error => {
      console.error('Error exportando métricas:', error);
      alert('Error al exportar las métricas');
    });
  }
}
